import React, { useState } from 'react';
import './App.css';
import HomePage from './components/HomePage';
import CreateRoom from './components/CreateRoom';
import JoinRoom from './components/JoinRoom';
import Matchmaking from './components/Matchmaking';
import CaroGame from './components/CaroGame';
import SinglePlayerGame from './components/SinglePlayerGame';
import StatsLeaderboard from './components/StatsLeaderboard';
import EnvironmentInfo from './components/EnvironmentInfo';
import config from './config/environment';

function App() {
  const [currentView, setCurrentView] = useState('home');
  const [gameData, setGameData] = useState(null);

  const navigate = (view, data = null) => {
    setCurrentView(view);
    setGameData(data);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'home':
        return <HomePage onNavigate={navigate} />;
      case 'create-room':
        return <CreateRoom onNavigate={navigate} />;
      case 'join-room':
        return <JoinRoom onNavigate={navigate} />;
      case 'matchmaking':
        return <Matchmaking onNavigate={navigate} />;
      case 'single-player':
        return <SinglePlayerGame onNavigate={navigate} />;
      case 'stats':
        return <StatsLeaderboard onNavigate={navigate} />;
      case 'game':
        return <CaroGame gameData={gameData} onNavigate={navigate} />;
      default:
        return <HomePage onNavigate={navigate} />;
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1 onClick={() => navigate('home')}>🎯 Caro Multiplayer</h1>
      </header>
      {renderCurrentView()}
      <EnvironmentInfo show={config.isDevelopment()} />
    </div>
  );
}

export default App;
